import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IIAPConnectResponse } from "../../interfaces";

export interface InsertAppleIAPPayload {
  formData: FormData;
}

export const useInsertAppleIAP = () => {
  return useMutation<IIAPConnectResponse, Error, InsertAppleIAPPayload>({
    mutationFn: async ({ formData }) => {
      return httpService.post<IIAPConnectResponse, FormData>(
        API_CONFIG.path.appleAdsAccounts,
        formData,
      );
    },
    // onSuccess is intentionally omitted — handled in the calling container
    // so cache invalidation fires only after the full app-selection flow completes.
  });
};
